import React from 'react';

import { useIntl } from 'react-intl';

import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters';
import { filter as labelFilter } from '../../../../../controllers/store/search/filters/label';
import { i18n } from './messages';

const LabelFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [
		filterData,
		{ loadInitialOptions, setLookupInput, setOption, clearLookupInput, clearOptions },
	] = useSelectFilter({
		filterId: labelFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { isLoading, selectedOptions, options, isLookupDefined, lookupInput, isLookupActive } =
		filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.confluenceFilterLabelSelected),
			options: selectedOptions,
		},
	];

	return (
		<SelectFilter
			canClearFilter
			checkboxIndicators
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSearchInputChange={setLookupInput}
			onSelectChange={setOption}
			options={isLookupActive ? options : groupedOptions}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.label)}
			noOptionsMessage={formatMessage(i18n.confluenceFilterLabelsNoText)}
			placeholder={formatMessage(i18n.confluenceFilterLabelPlaceholder)}
			filterOrControlId={'label'}
			isLoading={isLoading}
			isSearchable={isLookupDefined}
			searchInput={lookupInput}
			onClearOptions={clearOptions}
			minMenuWidth={'360px'}
		/>
	);
};

export default LabelFilter;
